/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { feePlansListPartnerPricingAgreements } from "../../funcs/feePlansListPartnerPricingAgreements.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListPartnerPricingAgreementsRequest$inboundSchema,
};

export const tool$feePlansListPartnerPricingAgreements: ToolDefinition<
  typeof args
> = {
  name: "fee-plans-list-partner-pricing-agreements",
  description: `List all partner pricing agreements associated with an account.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/profile.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await feePlansListPartnerPricingAgreements(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
